import React from "react";
import styled from "styled-components";

export default styled.div`
    width: 5%;
    float: left;
    color: #515151;
    
    margin-bottom: 25px;
`;